<template>
  <div class="people-container px-3 py-3 d-flex" v-if="people">
    <div class="image mr-3">
      <img v-if="profileImageUrl" :src="profileImageUrl" />
      <img v-else src="/static/icons/user-profile-default.png" />
    </div>
    <div class="info">
      <div class="name"><b class="text-active">ชื่อ: </b>{{ people.fullname }}</div>
      <div class="name"><b class="text-active">ชื่อใน App: </b>{{ people.fullnameApp }}</div>
      <div
        v-if="role === 'owner'"
        class="status text-active"
        :class="{
          'text-active': people.verifyStatus,
          'text-inactive': !people.verifyStatus
        }"
      >
        {{
          people.verifyStatus
            ? $t("feature.member.verified")
            : $t("feature.member.non_verify")
        }}
      </div>
      <div
        v-else
        class="status text-active"
        :class="{
          'text-active': people.isActive,
          'text-inactive': !people.isActive
        }"
      >
        {{
          people.isActive
            ? $t("feature.member.grant")
            : $t("feature.member.no_grant")
        }}
      </div>
      <div class="date label mb-2" v-if="people.verifyStatus">
        {{ $t("feature.member.at_date") }}
        {{ people.verifiedDate | moment-full }}
      </div>
      <div class="another d-flex">
        <div class="tel">
          <div class="label">{{ $t("feature.member.tel") }}</div>
          <div>{{ people.mobileNumber || "-" }}</div>
        </div>
        <div class="email">
          <div class="label">{{ $t("feature.login.email") }}</div>
          <div>{{ people.email || "-" }}</div>
        </div>
        <div
          class="message"
          v-show="people.verifyStatus && role === 'owner' && showGreeting"
        >
          <img src="/static/icons/send.svg" @click="onClickNewMessage" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: {
    people: {},
    role: {},
    showGreeting: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      profileImageUrl: null
    };
  },
  watch: {
    people() {
      this.downloadImage();
    }
  },
  mounted() {
    this.downloadImage();
  },
  methods: {
    downloadImage() {
      // clear image before get real image url
      this.profileImageUrl = null;
      if (this.people && this.people.profileImage) {
        axios
          .get(`${process.env.HOST}/api/downloads/image`, {
            params: {
              imageKey: this.people.profileImage
            }
          })
          .then(res => {
            this.profileImageUrl = res.data.url;
          });
      }
    },
    onClickNewMessage() {
      this.$emit("new-message", this.people, this.role);
    }
  }
};
</script>

<style lang="scss" scoped>
.people-container {
  border-bottom: solid 1px #f5f5f5;
  .image {
    width: 45px;
    height: 45px;
    overflow: hidden;
    border-radius: 10px;
    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
      position: relative;
    }
    .empty {
      width: 100%;
      height: 100%;
      border: 1px solid #ccc;
      border-radius: 10px;
    }
  }
  .info {
    flex: 1;
    .email {
      flex: 1;
    }
  }
  .tel {
    min-width: 120px;
  }
  .name {
    font-size: 16px;
    font-weight: bold;
  }
  .status {
    font-size: 14px;
    font-weight: bold;
  }
  .label {
    font-size: 11px;
    color: #8c8786;
  }
  .another {
    font-size: 16px;
    font-weight: 500;
    color: #4a4a4a;
  }
  .message {
    align-self: flex-end;
    width: 46px;
    img {
      width: 100%;
      cursor: pointer;
    }
  }
}
.text-active {
  color: #00b793;
}
.text-invite {
  color: #a28676;
}
.text-inactive {
  color: #8c8786;
}
</style>



// WEBPACK FOOTER //
// src/features/residents/components/People.vue